import { render, staticRenderFns } from "./CheckGroup.vue?vue&type=template&id=bc25ff76&scoped=true"
import script from "./CheckGroup.vue?vue&type=script&lang=js"
export * from "./CheckGroup.vue?vue&type=script&lang=js"
import style0 from "./CheckGroup.vue?vue&type=style&index=0&id=bc25ff76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc25ff76",
  null
  
)

export default component.exports